"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("./");
if (!('PluralRules' in Intl) ||
    new Intl.PluralRules('en', { minimumFractionDigits: 2 }).select(1) ===
        'one') {
    Object.defineProperty(Intl, 'PluralRules', {
        value: _1.PluralRules,
        writable: true,
        enumerable: false,
        configurable: true,
    });
}



//////////////////
// WEBPACK FOOTER
// ./~/@formatjs/intl-pluralrules/polyfill.js
// module id = 938
// module chunks = 0 1 2 3 4 5